import api from "@/lib/api";
import type { PaginatedResponse } from "@/types/common/api-types";
import type {
  Sale,
  SaleCheckout,
  SaleSearchParams,
  WalkInSaleCreate,
} from "@/types/sales/api-types/sale-types";

export const salesApi = {
  getAll: async (
    params: SaleSearchParams = {}
  ): Promise<PaginatedResponse<Sale>> => {
    const response = await api.get<PaginatedResponse<Sale>>("/sales", {
      params,
      // FastAPI `status: list[AppointmentStatus] = Query(None)` needs
      // `?status=booked&status=confirmed`, not `status[]=` / `status[0]=`.
      paramsSerializer: { indexes: null },
    });
    return response.data;
  },

  getById: async (id: number): Promise<Sale> => {
    const response = await api.get<Sale>(`/sales/${id}`);
    return response.data;
  },

  checkout: async (id: number, data: SaleCheckout): Promise<Sale> => {
    const response = await api.put<Sale>(`/sales/${id}/checkout`, data);
    return response.data;
  },

  createWalkIn: async (data: WalkInSaleCreate): Promise<Sale> => {
    const response = await api.post<Sale>("/sales/walk-in", data);
    return response.data;
  },
};
